/**
 * @flow
 * @relayHash c46be33c8d1217d6859bdc75980c0231
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RailsProjectSelectQueryVariables = {|
  orgDatabaseId: string,
  type: string,
  keywords?: ?string,
  fetchAllWhenEmpty: boolean,
  count: number,
  after?: ?string,
|};
export type RailsProjectSelectQueryResponse = {|
  +organization: ?{|
    +esSearchResults: {|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +databaseId: string,
          +title: ?string,
          +circleName: ?string,
        |}
      |}>,
      +pageInfo: {|
        +hasNextPage: boolean,
        +endCursor: ?string,
      |},
    |}
  |}
|};
export type RailsProjectSelectQuery = {|
  variables: RailsProjectSelectQueryVariables,
  response: RailsProjectSelectQueryResponse,
|};
*/


/*
query RailsProjectSelectQuery(
  $orgDatabaseId: String!
  $type: String!
  $keywords: String
  $fetchAllWhenEmpty: Boolean!
  $count: Int!
  $after: String
) {
  organization(databaseId: $orgDatabaseId) {
    esSearchResults(type: $type, keywords: $keywords, fetchAllWhenEmpty: $fetchAllWhenEmpty, first: $count, after: $after) {
      edges {
        node {
          databaseId
          title
          circleName
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchAllWhenEmpty"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "keywords"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orgDatabaseId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v6 = [
  {
    "kind": "Variable",
    "name": "databaseId",
    "variableName": "orgDatabaseId"
  }
],
v7 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "fetchAllWhenEmpty",
      "variableName": "fetchAllWhenEmpty"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "count"
    },
    {
      "kind": "Variable",
      "name": "keywords",
      "variableName": "keywords"
    },
    {
      "kind": "Variable",
      "name": "type",
      "variableName": "type"
    }
  ],
  "concreteType": "EsSearchResultConnection",
  "kind": "LinkedField",
  "name": "esSearchResults",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EsSearchResultEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EsSearchResult",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "databaseId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "circleName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasNextPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endCursor",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RailsProjectSelectQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RailsProjectSelectQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "c46be33c8d1217d6859bdc75980c0231",
    "metadata": {},
    "name": "RailsProjectSelectQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5754f44ce3ca98071ee8ad548623f6f1';

module.exports = node;
